import * as React from 'react';
import { initializeIcons } from '@fluentui/react';
import TaskPane from './TaskPane';

// Initialize Fluent UI icons
initializeIcons();

export interface AppProps {}

const App: React.FunctionComponent<AppProps> = () => {
  return <TaskPane />;
};

export default App;
